import { setCurrentPage } from "./actions"

const extraReducers = {
  [setCurrentPage.fulfilled]: (state, action) => {
    state.currentPage = action.payload
    // @todo: make sure next page is available
    state.nextPage = state.currentPage+1

    if(action.payload > 0){
      state.previousPage = state.currentPage-1
    }
  },
}

export default extraReducers
